<template>
  <div class="preview-box">
    <template v-if="planForm.project_name">
      <Divider title="基础信息"></Divider>
      <LabelRow label="计划名称：">{{ planForm.project_name }}</LabelRow>
      <LabelRow label="应用平台：">{{ PLATFORM_LIST.find((item) => item.value === planForm.ch_platform_id).label }}</LabelRow>
      <LabelRow label="应用：">{{ planForm.game_id.name }}</LabelRow>
      <LabelRow label="回调开关：">
        <el-switch
          :value="planForm.callback_switch"
          :disabled="[PLATFORM.IOS, PLATFORM.MINIGAME].includes(planForm.ch_platform_id)"
        ></el-switch>
      </LabelRow>
      <Divider title="营销目的及场景"></Divider>
      <LabelRow label="计划场景：" v-if="marketingSceneType.version3">腾讯3.0</LabelRow>
      <LabelRow label="计划场景：" v-if="marketingSceneType.version_smart">腾讯-智投</LabelRow>
      <LabelRow label="计划场景：" v-if="marketingSceneType.version_search">搜索</LabelRow>
      <LabelRow label="投放场景：" v-if="marketingSceneType.version_smart">
        <span v-if="SMART_DELIVERY_PLATFORM.MINI_GAME_PROMOTION === planForm.smart_delivery_platform">小游戏跑量</span>
        <span v-if="SMART_DELIVERY_PLATFORM.GAME_APP === planForm.smart_delivery_platform">游戏应用智投</span>
      </LabelRow>
      <LabelRow label="推广目的：">用户增长</LabelRow>

      <template v-if="marketingSceneType.version_smart || marketingSceneType.version3">
        <LabelRow label="子目的：">{{ marketingSubGoalName }}</LabelRow>
      </template>

      <LabelRow label="营销对象：">
        {{ planForm.promotedObject.promoted_object_name }}（{{ planForm.promotedObject.promoted_object_id }}）
      </LabelRow>

      <template v-if="marketingSceneType.version_search">
        <LabelRow label="计划日预算：">
          <span v-if="planForm.budget === 1">
            {{ planForm.daily_budget }}
          </span>
          <span v-else>不限</span>
        </LabelRow>
      </template>

      <Divider title="排期和出价设置"></Divider>
      <LabelRow label="日预算：">
        <span v-if="budgetForm.budget === 0">不限</span>
        <span v-else>{{ budgetForm.daily_budget }}元</span>
      </LabelRow>
      <template v-if="marketingSceneType.version_smart">
        <LabelRow label="优选版位提价：">
          <span>{{ budgetForm.bid_adjustment_enabled ? '开启' : '关闭' }}</span>
        </LabelRow>
        <template v-if="budgetForm.bid_adjustment_enabled">
          <LabelRow label="选择版位：">{{ bidAdjustmentSiteNames || '-' }}</LabelRow>
          <LabelRow label="浅层提价系数：">{{ budgetForm.bid_adjustment_shallow_coefficient || '-' }}</LabelRow>
          <LabelRow label="深层提价系数：">{{ budgetForm.bid_adjustment_deep_coefficient || '-' }}</LabelRow>
        </template>
      </template>
      <LabelRow label="投放日期：">{{ budgetForm.rangeDate[0] }} ~ {{ budgetForm.rangeDate[1] }}</LabelRow>
      <LabelRow label="投放时段：">
        <ReadableWeekdays v-if="budgetForm.timeRange" :list="budgetForm.readableWeekdays"></ReadableWeekdays>
        <span v-else>不限</span>
      </LabelRow>
      <LabelRow label="投放场景：" v-if="marketingSceneType.version3">
        <span v-if="BID_SCENE.NORMAL_AVERAGE === budgetForm.bid_scene">常规投放</span>
        <span v-else>最大转化量投放</span>
      </LabelRow>

      <template v-if="marketingSceneType.version_search">
        <LabelRow label="投放场景：">
          <span v-if="BID_SCENE.NORMAL_TARGET === budgetForm.bid_scene">常规投放-放量投放</span>
          <span v-else>常规投放-稳定投放</span>
        </LabelRow>
      </template>

      <LabelRow label="计费方式：">
        <span v-if="BUDGET_CONST.BID_MODE.OCPM === budgetForm.bid_mode">OCPM</span>
        <span v-else>OCPC</span>
      </LabelRow>

      <template v-if="marketingSceneType.version_smart">
        <!-- 智投-小游戏跑量 -->
        <template v-if="SMART_DELIVERY_PLATFORM.MINI_GAME_PROMOTION === planForm.smart_delivery_platform">
          <LabelRow label="智投投放目标：" v-if="budgetForm.smart_delivery_goal">
            {{ SMART_DELIVERY_GOAL_LIST.find((goal) => goal.value === budgetForm.smart_delivery_goal)?.label }}
          </LabelRow>

          <template v-if="budgetForm.smart_delivery_goal === SMART_DELIVERY_GOAL.SEVEN_DAY_PURCHASE_ROI">
            <LabelRow label="注册成本：">
              {{ budgetForm.smart_promotion_spec.register_cost }}
            </LabelRow>
            <LabelRow label="7日付费ROI：">
              {{ budgetForm.smart_promotion_spec.seven_day_purchase_roi }}
            </LabelRow>
          </template>

          <template v-if="budgetForm.smart_delivery_goal === SMART_DELIVERY_GOAL.DAY30_PURCHASE">
            <LabelRow label="注册成本：">
              {{ budgetForm.smart_promotion_spec.register_cost }}
            </LabelRow>
            <LabelRow label="30日付费ROI：">
              {{ budgetForm.smart_promotion_spec.day30_purchase_roi }}
            </LabelRow>
          </template>

          <template v-if="budgetForm.smart_delivery_goal === SMART_DELIVERY_GOAL.FIRST_DAY_PURCHASE_ROI">
            <LabelRow label="注册成本：">
              {{ budgetForm.smart_promotion_spec.register_cost }}
            </LabelRow>
            <LabelRow label="首日付费ROI：">
              {{ budgetForm.smart_promotion_spec.first_day_purchase_roi }}
            </LabelRow>
          </template>

          <template v-if="budgetForm.smart_delivery_goal === SMART_DELIVERY_GOAL.IAAP_MIX_IN_ONE">
            <LabelRow label="混变ROI：">
              {{ budgetForm.smart_promotion_spec.iaap_roi }}
            </LabelRow>
            <LabelRow label="混变系数：">
              {{ budgetForm.smart_promotion_spec.iaap_mix_in_one_factor }}
            </LabelRow>
          </template>

          <template v-if="budgetForm.smart_delivery_goal === SMART_DELIVERY_GOAL.BACK_FLOW_1DAY_PURCHASE_ROAS">
            <LabelRow label="沉默唤起成本：">
              {{ budgetForm.bid_amount_deep_conversion_worth_rate_spec?.bid_amount }}
            </LabelRow>
            <LabelRow label="首日付费ROI：">
              {{ budgetForm.bid_amount_deep_conversion_worth_rate_spec?.deep_conversion_worth_rate }}
            </LabelRow>
          </template>
        </template>
        <!-- 智投-游戏应用智投 -->
        <template v-if="SMART_DELIVERY_PLATFORM.GAME_APP === planForm.smart_delivery_platform">
          <LabelRow label="智投投放目标：" v-if="budgetForm.smart_delivery_goal">
            {{ SMART_DELIVERY_GOAL_APP_LIST.find((goal) => goal.value === budgetForm.smart_delivery_goal)?.label }}
          </LabelRow>
          <template v-if="SMART_DELIVERY_GOAL.GAME_APP_ACTIVATE_ROI_1DAY === budgetForm.smart_delivery_goal">
            <LabelRow label="激活成本：">
              {{ budgetForm.game_app_activate_roi_spec.bid_amount }}
            </LabelRow>
            <LabelRow label="首日付费ROI：">
              {{ budgetForm.game_app_activate_roi_spec.deep_conversion_worth_rate }}
            </LabelRow>
          </template>

          <template v-if="SMART_DELIVERY_GOAL.ACTIVATE === budgetForm.smart_delivery_goal">
            <LabelRow label="激活成本：">
              {{ budgetForm.bid_amount_spec.bid_amount }}
            </LabelRow>
          </template>
        </template>
      </template>

      <template v-if="marketingSceneType.version3 || marketingSceneType.version_search">
        <LabelRow label="优化目标：">
          {{ OPT_GOAL_LIST.find((goal) => goal.value === budgetForm.optimization_goal).label }}
        </LabelRow>
        <LabelRow label="出价：" v-if="BID_SCENE.NORMAL_AVERAGE === budgetForm.bid_scene">
          <span v-if="budgetForm.bid_range === 0">{{ budgetForm.bid_amount }} </span>
          <span v-else> {{ budgetForm.bid_num_range[0] }} ~ {{ budgetForm.bid_num_range[1] }} </span>
        </LabelRow>

        <template v-if="marketingSceneType.version_search">
          <LabelRow label="出价：">
            <span v-if="budgetForm.bid_range === 0">{{ budgetForm.bid_amount }} </span>
            <span v-else> {{ budgetForm.bid_num_range[0] }} ~ {{ budgetForm.bid_num_range[1] }} </span>
          </LabelRow>
        </template>
      </template>
      <LabelRow
        label="成本控制："
        v-if="BID_SCENE.NORMAL_MAX === budgetForm.bid_scene && budgetForm.cost_constraint_scene === COST_CONTROL.OPEN"
      >
        <span>{{ budgetForm.custom_cost_cap }} </span>
      </LabelRow>
      <template v-if="budgetForm.deep_bid_mode && (marketingSceneType.version3 || marketingSceneType.version_search)">
        <LabelRow label="深度转化类型：">
          <span v-if="DEEP_CONVERSION_TYPE.BEHAVIOR === deepConversionSpec.deep_conversion_type"> 优化转化行为 </span>
          <span v-else>优化ROI</span>
        </LabelRow>
        <LabelRow label="深度优化目标：">
          <template v-if="conversionType.isBehavior">
            <span>
              {{ OPT_GOAL_LIST.find((goal) => goal.value === deepConversionSpec.deep_conversion_behavior_spec.goal).label }}
            </span>
          </template>

          <template v-if="conversionType.isWorth">
            <span>
              {{ OPT_ROI_GOAL_LIST.find((goal) => goal.value === deepConversionSpec.deep_conversion_worth_spec.goal).label }}
            </span>
          </template>
        </LabelRow>

        <LabelRow label="深度出价：" v-if="conversionType.isBehavior && BID_SCENE.NORMAL_AVERAGE === budgetForm.bid_scene">
          <span v-if="deepConversionSpec.deep_conversion_behavior_spec.deep_bid_range">
            {{ deepConversionSpec.deep_conversion_behavior_spec.deep_deepbid_num_range[0] }}
            ~
            {{ deepConversionSpec.deep_conversion_behavior_spec.deep_deepbid_num_range[1] }}
            元
          </span>
          <span v-else>{{ deepConversionSpec.deep_conversion_behavior_spec.bid_amount }}</span>
        </LabelRow>

        <LabelRow label="深度roi系数：" v-if="conversionType.isWorth && BID_SCENE.NORMAL_AVERAGE === budgetForm.bid_scene">
          <span>{{ deepConversionSpec.deep_conversion_worth_spec.expected_roi }}</span>
        </LabelRow>
      </template>

      <template v-if="budgetForm.auto_acquisition_enabled">
        <LabelRow label="一键起量：">
          <el-switch :value="budgetForm.auto_acquisition_enabled"></el-switch>
        </LabelRow>
        <LabelRow label="一键起量预算：">
          <span>{{ budgetForm.auto_acquisition_budget }}元</span>
        </LabelRow>
      </template>

      <LabelRow label="自动衍生创意：" v-if="budgetForm.auto_derived_creative_enabled">
        <span>开启</span>
      </LabelRow>

      <template v-if="budgetForm.search_expansion_switch === SEARCH_EXPANSION_SWITCH.OPEN">
        <LabelRow label="搜索场景扩量：">
          <span>开启</span>
        </LabelRow>

        <LabelRow label="定向扩展：">
          <span v-if="budgetForm.search_expand_targeting_switch === SEARCH_EXPAND_TARGETING_SWITCH.OPEN"> 开启 </span>
          <span v-else> 关闭 </span>
        </LabelRow>
      </template>
      <LabelRow label="投放素材标签：" v-if="budgetForm.material_package_name">
        <span>{{ budgetForm.material_package_name }}</span>
      </LabelRow>

      <LabelRow label="转化类型：">
        <span v-if="ACCESS_TYPE.SDK === budgetForm.access_type">SDK类型</span>
        <span v-if="ACCESS_TYPE.API === budgetForm.access_type">API类型</span>
      </LabelRow>
    </template>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import Divider from '@/views/create/bytedance/components/layout/title-divider.vue'
import LabelRow from '@/views/create/bytedance/components/layout/label-row.vue'
import ReadableWeekdays from '@/views/edit/kuaishou/components/time-range/weekdaysTextTransformer.vue'

import { PLATFORM_LIST } from '@/common/js/constants.js'
import { BID_ADJUSTMENT_SITE_OPTIONS } from '@/views/create/gdt/model/budget/bid-adjustment.js'
import BUDGET_CONST, {
  DEEP_CONVERSION_TYPE,
  BID_SCENE,
  ACCESS_TYPE,
  OPT_GOAL_LIST,
  OPT_ROI_GOAL_LIST,
  SMART_DELIVERY_GOAL,
  SMART_DELIVERY_GOAL_LIST,
  SMART_DELIVERY_GOAL_APP_LIST,
  COST_CONTROL,
  SEARCH_EXPANSION_SWITCH,
  SEARCH_EXPAND_TARGETING_SWITCH
} from '@/views/create/gdt/model/budget/budget-const.js'

import {
  PLATFORM,
  SMART_DELIVERY_PLATFORM,
  MINI_GAME_MARKETING_SUB_GOAL_LIST,
  MARKETING_SUB_GOAL_LIST,
  AD_MARKETING_SCENE
} from '@/views/create/gdt/model/project-const.js'

// eslint-disable-next-line
const props = defineProps({
  form: Object
})
const planForm = computed(() => props.form.planForm)
const budgetForm = computed(() => props.form.budgetForm)

const bidAdjustmentSiteNames = computed(() => {
  const siteSet = budgetForm.value.bid_adjustment_site_set || []
  const unknownSites = budgetForm.value.bid_adjustment_unknown_sites || []
  return [...new Set([...siteSet, ...unknownSites])]
    .map((site) => BID_ADJUSTMENT_SITE_OPTIONS.find((item) => item.value === site)?.label || site)
    .join('、')
})

const marketingSubGoalName = computed(() => {
  const list = planForm.value.ch_platform_id === PLATFORM.MINIGAME ? MINI_GAME_MARKETING_SUB_GOAL_LIST : MARKETING_SUB_GOAL_LIST
  const subGoal = list.find((item) => item.value === planForm.value.marketing_sub_goal)
  return subGoal?.label
})

const deepConversionSpec = computed(() => budgetForm.value.deep_conversion_spec)
const conversionType = computed(() => {
  const type = deepConversionSpec.value.deep_conversion_type
  return {
    isBehavior: type === DEEP_CONVERSION_TYPE.BEHAVIOR,
    isWorth: type === DEEP_CONVERSION_TYPE.WORTH
  }
})

const marketingSceneType = computed(() => {
  const { ad_marketing_scene } = planForm.value
  return {
    // ad_marketing_scene undefined 兼容老模板
    version3: typeof ad_marketing_scene === 'undefined' || ad_marketing_scene === AD_MARKETING_SCENE.VERSION_3,
    version_smart: ad_marketing_scene === AD_MARKETING_SCENE.VERSION_SMART,
    version_search: ad_marketing_scene === AD_MARKETING_SCENE.VERSION_SEARCH
  }
})
</script>

<style lang="scss" scoped>
.preview-box {
  height: 720px;
  overflow: auto;
  padding: 10px;
  .empty {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
